import TextHeading from "components/TextHeading";
import React from "react";

const SignupSuccess = () => (
  <div>
    <div className="signup-form__success">
      <div className="signup-form__message">
        <div className="signup-form__message-content">
          <TextHeading level={3} marginBottom="half" size={4}>
            Almost done - check your email
          </TextHeading>
          <p>
            Please go to your email account and click on the link in the email.
            Once you do this, your fundraiser page will be live.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default SignupSuccess;
